import React, { Component, useState } from "react";
import Slider from "react-slick";
import Header from "./Common/Header";
import Footer from "./Common/Footer";
import cookie from "react-cookies";
import { logout } from "../utills/API";
import { Nav, Button, Form, Tabs, Tab, Accordion, Card } from "react-bootstrap";
import shop from "../assets/images/gainon/shop.svg";
import redeem from "../assets/images/gainon/redeem.svg";
import invite from "../assets/images/gainon/invite-icon.svg";
import share from "../assets/images/gainon/share-icon.svg";
import copyicon from "../assets/images/gainon/copy-icon.svg";
import completeImg from "../assets/images/gainon/thankyou-img.svg";
import "slick-carousel/slick/slick.css";
import SvgVoucher from "../components/Common/SvgVoucher";
import "slick-carousel/slick/slick-theme.css";

function ControlledTabs() {
  const [key, setKey] = useState("home");

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      variant="gotabs"
    >
      <Tab eventKey="home" title="How to Redeem">
        <div>
          <h1>Home</h1>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Libero
            nemo inventore quas corrupti incidunt id consequatur accusamus,
            deleniti ea sed magni alias blanditiis aut, mollitia aliquam eaque
            rem ad natus?
          </p>
        </div>
      </Tab>
      <Tab eventKey="profile" title="Description">
        <div>
          <h1>Profile asdasdds</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
            deleniti a nesciunt praesentium omnis quaerat accusamus veritatis
            ipsa quia voluptatem. Corporis deleniti, facilis repellat provident
            quisquam culpa sit perspiciatis facere!
          </p>
        </div>{" "}
      </Tab>
      <Tab eventKey="contact" title="Terms & Condition">
        <div>
          <h1>Contact asdasdds</h1>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestiae,
            ipsum sed a suscipit ullam totam deserunt reprehenderit blanditiis
            eius, quisquam eveniet ut esse odit officia! Id, consequuntur
            laborum. Non, neque.
          </p>
        </div>
      </Tab>
    </Tabs>
  );
}
class Temp extends Component {
  // constructor(props) {
  //   super(props);
  // }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  isCurrentUser = () => {
    return !!cookie.load("accessToken");
  };

  logout = async () => {
    await logout();
    // this.props.history.push("/login");
  };

  render() {
    var settings = {
      dots: true,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      initialSlide: 0,
      variableWidth: true,
      centerPadding:0,
      // variableHeight: true,
      // responsive: [
      //   {
      //     breakpoint: 700,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       centerMode: true,
      //       variableWidth: true,
            
      //       // infinite: true,
      //       // dots: true
      //     }
      //   },
      // ],
      appendDots: (dots) => (
        <div
          style={{
            padding: "28px 10px 10px",
          }}
        >
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
      ),
      customPaging: (i) => (
        <div
          style={{
            width: "26px",
            color: "#333333",
            borderRadius: "2px",
            fontWeight: "600",
          }}
        >
          {i + 1}
        </div>
      ),
    };
    return (
      <>
        <Header logout={this.logout} isCurrentUser={this.isCurrentUser()} />
        <section className="page page-order-completed">
          <div className="order-complete-wrap text-center mb-3">
            <img src={completeImg} alt="Complete Logo" />
            <h1 className="text-22 font-weight-bold mb-2">Order completed!</h1>
            <p className="text-16">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
              >
                <g transform="translate(-1173 -24)">
                  <g transform="translate(1147 12)">
                    <g transform="translate(0 9)">
                      <g transform="translate(26 1)">
                        <g transform="translate(0 2)">
                          <rect width="14" height="14" fill="none" />
                          <path
                            d="M9.215,12.833v-.1L5.264,8.154A4.565,4.565,0,0,0,8,7.433a2.872,2.872,0,0,0,1.13-2.147h1.218l.369-1.266H9.111a3.262,3.262,0,0,0-.649-1.587h1.891l.369-1.266H3.309L2.933,2.433H5.184Q7.155,2.5,7.54,4.019H3.285L2.917,5.285H7.556a1.873,1.873,0,0,1-.793,1.166,2.862,2.862,0,0,1-1.627.437h-2l.008,1L7.4,12.833Z"
                            fill="#29C009"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <span style={{ color: "#29C009" }}>500</span> has been added to
              your wallet.
            </p>
          </div>
          {/* className="slick-no-slide" */}
          <Slider {...settings}>
            <div>
              <div className="box-vouchcer">
                <div className="content">1</div>
              </div>
           </div> 
           <div>
             <div className="box-vouchcer"><div className="content">2</div></div>
             </div> 
           <div>
             <div className="box-vouchcer"><div className="content">2</div></div>
             </div> 
            {/* <div><div className="box-vouchcer">3</div></div> 
            <div><div className="box-vouchcer">4</div></div>   */}
            
                       {/* <SvgVoucher blue />
            <SvgVoucher blue />
            <SvgVoucher purple /> */}
          </Slider>
          <div className="text-center my-5">
            <Button variant="primary">
              Take me to Flipkart
              <i className="icon-external-link-alt font-weight-bold ml-3" />
            </Button>{" "}
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <Button variant="link" className="mr-4">
              <i className="icon-share font-weight-bold mr-2" /> Share
            </Button>
            <Button variant="link">
              <i className="icon-download font-weight-bold mr-2" />
              Download
            </Button>
          </div>
        </section>
        {/* <section className="page page-voucher pt-5">
          <div className="container">
            <div className="flex-xl-nowrap row">
              <div className="col-auto d-flex flex-column">
                <Nav
                  variant="sidebar"
                  defaultActiveKey="/home"
                  className="flex-column "
                >
                  <Nav.Link href="/home">All Categories</Nav.Link>
                  <Nav.Link eventKey="link-1">Eazydiner</Nav.Link>
                  <Nav.Link eventKey="link-2">Apparels & Accessories</Nav.Link>
                  <Nav.Link eventKey="link-2">E-Com & Online</Nav.Link>
                </Nav>
              </div>
              <div className="col">
                <h1>Template page</h1>
                <p>content</p>
                <hr />
                <h2>Forms</h2>
                <Form>
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" />
                    <Form.Text className="text-muted">
                      We'll never share your email with anyone else.
                    </Form.Text>
                  </Form.Group>
                  <Form.Group controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" />
                  </Form.Group>
                  <Form.Group controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" label="Check me out" />
                  </Form.Group>
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>{" "}
                  <Button variant="secondary" type="reset" className="mr-1">
                    Reset
                  </Button>
                  <Button variant="link">Label</Button>
                </Form>
                <hr />
                <Button variant="primary">Purchase</Button>{" "}
                <Button variant="primary" disabled>
                  Purchase
                </Button>
                <hr />
                <ControlledTabs />
                <Nav
                  defaultActiveKey="/voucher"
                  as="ul"
                  className="go-nav"
                  activeKey="/home"
                >
                  <Nav.Item as="li" className="mr-3">
                    <Nav.Link href="/voucher">
                      <img src={shop} alt="shop" />
                      Shop
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li" className="mr-3">
                    <Nav.Link href="/voucher">
                      <img src={redeem} alt="redeem" />
                      Redeem
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <hr />
                <div className="brand-box-wrap mb-4">
                  {[1, 2, 3, 4, 5].map((brand) => (
                    <div className="brand-box">
                      <div className="w-100 d-flex flex-grow-1 flex-column align-items-center justify-content-center">
                        <div className="brand-logo">
                          <img
                            alt="asd"
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAIAAACzY+a1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjIgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzY5QzE0RkRDNkE3MTFFQUI3NzZGNzA0QzNBQTkyNEIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzY5QzE0RkVDNkE3MTFFQUI3NzZGNzA0QzNBQTkyNEIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3NjlDMTRGQkM2QTcxMUVBQjc3NkY3MDRDM0FBOTI0QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3NjlDMTRGQ0M2QTcxMUVBQjc3NkY3MDRDM0FBOTI0QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pp/cjdEAAAdVSURBVHja7J0Lc6IwFIUForj//79W3tnDvcWibTWEQGI9Z2ecWbW15st9JoHsUnUH6pWVcwiIkCJCigiJkCJCiggpIiRCiggpIqSIkAgpIqSIkCJCIqSIkCJCigiJkCJCiggpIiRCiggpIqSI8A1lVv78MAx2GLq+H0QcUEdlWZaLiqLAI/4bAaG1tuvArrd25AjhObJxHr1x9oNc33dFjn+FMWZXhPh48GvbBvDIY4UVYPofukOv/GCRHuZo/Pg1Td22PJgYTJ3oJFpK0Xjwq6oK/vMH/64+foVbfxvrG+xPzqttWzwupWiWWn5d18MtP3ze8Xi8OgF9IKeHoyg+1CIY9TC++QugWIxxsXAfQ7PQ3tv5R8qUATyjORXtbyHIERZmP7BdRxXPIkhl2RmvhUcI51nXzZ3xQeBHIF5lxWdpoVMfqal6VxRoIKovhSztMTukfvhy4YAHr01+6wWDK8ubkcRQ33m7AAj7sXj/CoFak9JzhhKG05jjPGfU1CYkQvCbl4CoY2h/wW3xahKS7NjgVnjTP9PmEMc9qCFKXNyuOyP87CwWe+XR1zg+PVLzBAcIx2hlt0F4Z9lIlxx/Cn8Tqh/tosokyDTXgit2z5vfpMjwc2zG+/NcMiCkVYB3l8qqCeL5QoI4Qfo5ts0RAlvTNL9lxrrKgdfMMKAyIUUZEw03aSCEhV0uFxdLVTM9n8+k6J8HBbd6kKuqyn3tcFwx7lr3HJoKg/CxYUnwczbosUPfuVey+0sL7R8XZ/4gQl0K9nDLGKM0DVEWRxv4FTymSTEwwl7SUL/gmuDWG10cVQ+BqfnbQumfQmj9N2LY77VHXIEZkrJ5Z9gK0a5La7uCCcnP2n6FJclatk2ha6O1LIzvzjFYodg0Nf5OY0wiDSYT1AbX2VAaFqjhHJHvN5cg7eL6IL3+FCiGdKTZuv2QWQJ9c02smrp+7NK1cEokBTOBZ4Q/hiz61o3RuOp6XD13ez886kGWvuP+2XlwhN4U464hy7aSGun0gorWgiJUx82lAyMsvHYlZ/KDsRYgtWFb12OqaZf/bNO0cQv/wKMGM/JY0M+L4nQ6ReRXVRckKd6/RGyxiWWL4Sc++El4WBKQIy05iQ0hd6nWJyURC//wCHVz4nwzz2OVZYn3xwp+klUGyoYerq+9TEZ6pairgA+CxBj/xPiiZHRauYftrdtp7Wzn1MxsZd1SI+Khbbtp14XkcNPGGd174X0ia6XTG48VbBO6pK16KcvzboX/hiOILyB79QttYSvICW20DfywvPpZ5b46xB4kvpb7OJjNjUC/QyGaPXnY/+iMdl72aangE+SDhtOp3JriHn7M9zvYgJh12bZtm906YrLQCF+dbX3sJEIocrQYZBzzUyOpJS/uJSO+zfG44eETkyY/zTimksOsMcfPzlm87knTtEgD8EVkr3b29xEifuA7j70ucXna9fA4vqy/THflzJdto6jvMSMt4mIQp5I0Qoy18PsqtyWGjUt3Sw/CqSlH7HvdZTddh2nUaB0VlqJJxvisbjT63t2YsrtPii7fX5NPdcXpSFzLILVWyMI/T4SfblR50J26vuFpSaDrsanxmzyqLkmG3CUU3wo13Xdk8zQ0avISPfg98Td9H7CtbxLg14Cg46zU92MYjt9Co9YhKe/ZnRe8fyEWPgh+T1MDMB9uQ6M28JLdrXvb6DiEzUlNLH5a+XmHBN32j2JLG+WSfNbveS4jAkL34OcSGvX6Ht2SPS9EuDIl64Pwu84GuZ7g4Z3PRe2H0Dv4uUTHd5bZjd/K4EfFRCi9Epgfz4G+IEJ1ngGDH7UrQq21x2sH8+Kzr4gwqYUCIvSr2Gq9YhCH+PUQTueDega/10N4bTSndpSZCBf5zxdoNP8xBT/ZxCF9cYQUEVJESIQUEVJESBEhEVJESBEhRYRESBEhRYQUERIhRYRU2giztz/GsJ3sPggtbyC5M6UtHCkRbkFxPAC8/JcZX4QPXyHfx2P36/AJw41uBCtm97W598dYiPeU5clGusr2S0H84UKeeMZv87QrwjzP+95eZ8iPHyZ/GO8k6a/x/MJyiK6xUO5BkM8/jPvtg/PrxUq2QpjnN9ec6nseeQmd4tgvq5BwmQW3wuLWCnue+gxrgk3TzsOWMUVghHcXf5NL+42nP2mLQeyvbW/OohSFOR5PgRGqIc7v6TJeCr6ugVHjolgkjdIdm9VT7CBXVfV3E3S/cueCulDuIWLubsxY1+MV1PA8Jo4WHiz8n8KbEML4uvFGbbcz/3Q6IvNYwOVSLTsLCH4fHx93UVCnzJUcET4jeAU53PGDMZTledEALu7OgNa/f2e99vJNQUOtbtog/nnc2sKnwQafeTplU3U4MC1d36yBYei9jzwupO/ZI8XnlWU5nckmwxX85A64eosrvwC0OBZSqYmr9kRIESFFhERIESFFhBQREiFFhBQRUkRIhBQRUkRIESERUkRIESFFhERIESFFhBQREiFFhBQRUkT4jvovwACOtaNLyQNG3wAAAABJRU5ErkJggg=="
                          />
                        </div>
                      </div>
                      <p>Name</p>
                      <strong>Upto 25% Off</strong>
                      <div className="button-wrap">
                        <Button
                          variant="primary"
                          block
                          onClick={() =>
                            this.props.clickOnEasyDineBrand(this.props.brand)
                          }
                        >
                          Purchase
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="brand-box-wrap mb-4">
                  {[1, 2, 3, 4, 5].map((brand) => (
                    <div className="voucher-box">
                      <div class="content">
                        <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                          <div className="brand-logo">
                            <img
                              alt="asd"
                              src="data:image/png;base64,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"
                            />
                          </div>
                        </div>
                        <p>Name</p>
                      </div>
                    </div>
                  ))}
                </div>
                <hr />
                <h2>Accordion</h2>
                <Accordion defaultActiveKey="0" bsPrefix="gofaq">
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      variant="link"
                      eventKey="0"
                    >
                      How do I make a payment?
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body className="pt-0">
                        Select any brand, enter the amount, and complete the
                        payment using Razorpay or Paytm gateway. You will then
                        receive e-voucher(s) with loaded cash that can be used
                        at the selected brand.
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      variant="link"
                      eventKey="1"
                    >
                      How do I make a payment?
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>Hello! I'm another body</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      variant="link"
                      eventKey="2"
                    >
                      How do I make a payment?
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>Hello! I'm another body</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
                <h2>Switcher</h2>
                <Form>
                  <Form.Check type="switch" id="custom-switch" label="" />
                </Form>
                <hr />
                <Card className="card-refer">
                  <Card.Body className="text-center">
                    <img src={invite} className="mb-4" alt="Invite image" />
                    <h4>Earn by referring friends to Gainon</h4>
                    <p>
                      You will get a Reward card when your friends do their
                      first purchase
                    </p>
                    <div className="refer-code-box">
                      <span className="mr-3">H3HG727HG</span>
                      <img
                        className="copy-icon"
                        src={copyicon}
                        alt="Copy icon image"
                      />
                    </div>
                    <p>Copy & send this referral code to your friend</p>
                    <Button variant="link">
                      {" "}
                      <img
                        src={share}
                        className="mr-2"
                        alt="Share icon image"
                      />{" "}
                      Share
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </section> */}
        <Footer />
      </>
    );
  }
}

export default Temp;
